import type { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) => ({
  topNavBar: {
    backgroundColor: theme.palette.background.default,
    position: 'sticky',
    top: 0,
    width: '100%',
    zIndex: 10,
  },
  topNavBarItems: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    paddingLeft: 24,
    paddingRight: 24,
    paddingTop: 12,
    paddingBottom: 8,
    height: 56,
  },
}));

export default useStyles;
